import React, { FC } from "react";
import cn from "classnames";

import { Color } from "@baseTypes/baseType";

import st from "./sticker.module.scss"

interface Sticker extends React.HTMLAttributes<HTMLDivElement> {
    children?: React.ReactNode
    className?: string
    style?: React.CSSProperties
    blur?: boolean
    color?: Color
    radius?: boolean
    shadow?: boolean
}

const Sticker: FC<Sticker> = (props) => {

    const {
        className,
        style,
        children,
        blur = false,
        radius = true,
        shadow = true,
        color = Color.White,
        ...rest
    } = props

    return (
        <div
            className={cn(
                st.sticker,
                color && st[`color__${color}`],
                blur && st[`color__${color}__blur`],
                radius && st.radius,
                shadow && st.shadow,
                className
            )}
            style={style}
            {...rest}
        >
            {children}
        </div>
    )
}
export default Sticker;